<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <mat-icon class="w-6 h-6">assessment</mat-icon>
        <h2 class="text-2xl font-bold mb-0">Berichte</h2>
      </div>

      <div class="flex space-x-2">
        <button (click)="loadReports()" mat-raised-button color="primary">
          <mat-icon class="w-5 h-5">refresh</mat-icon>
          Aktualisieren
        </button>
      </div>
    </div>

    <!-- Search and Filter -->
    <div class="mb-6">
      <div class="flex flex-col lg:flex-row gap-4 items-start lg:items-center">
        <!-- Search Box -->
        <div class="flex-1">
          <div class="w-full max-w-sm min-w-[200px]">
            <div class="relative">
              <input
                class="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md pl-3 pr-28 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow"
                placeholder="Suche Berichte..." 
                [(ngModel)]="searchTerm"
                (keyup)="onSearch()"
              />
              <button
                class="absolute top-1 right-1 flex items-center rounded bg-slate-800 py-1 px-2.5 border border-transparent text-center text-sm text-white transition-all shadow-sm hover:shadow focus:bg-slate-700 focus:shadow-none active:bg-slate-700 hover:bg-slate-700 active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                type="button"
                *ngIf="searchTerm"
                (click)="searchTerm = ''; onSearch()"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4 mr-2">
                  <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
                Clear
              </button>
            </div>
          </div>
        </div>

        <!-- Filter Controls -->
        <div class="flex flex-wrap gap-3 items-center">
          <!-- Client Filter -->
          <div class="min-w-[150px]">
            <select
              class="w-full px-3 py-2 text-sm border border-slate-200 rounded-md focus:outline-none focus:border-slate-400"
              [(ngModel)]="filters.client_id"
              (change)="onFilterChange()"
            >
              <option value="">Alle Kunden</option>
              <option *ngFor="let client of clients" [value]="client.id">
                {{ client.name }}
              </option>
            </select>
          </div>

          <!-- Standort Filter -->
          <div class="min-w-[150px]">
            <select
              class="w-full px-3 py-2 text-sm border border-slate-200 rounded-md focus:outline-none focus:border-slate-400"
              [(ngModel)]="filters.standort_id"
              (change)="onFilterChange()"
            >
              <option value="">Alle Standorte</option>
              <option *ngFor="let standort of standorte" [value]="standort.id">
                {{ standort.nummer }}: {{ standort.name }}
              </option>
            </select>
          </div>

          <!-- Status Filter -->
          <div class="min-w-[120px]">
            <select
              class="w-full px-3 py-2 text-sm border border-slate-200 rounded-md focus:outline-none focus:border-slate-400"
              [(ngModel)]="filters.status"
              (change)="onFilterChange()"
            >
              <option *ngFor="let option of statusOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>

          <!-- Date From -->
          <div class="min-w-[120px]">
            <input
              type="date"
              class="w-full px-3 py-2 text-sm border border-slate-200 rounded-md focus:outline-none focus:border-slate-400"
              [(ngModel)]="filters.date_from"
              (change)="onFilterChange()"
              placeholder="Von Datum"
            />
          </div>

          <!-- Date To -->
          <div class="min-w-[120px]">
            <input
              type="date"
              class="w-full px-3 py-2 text-sm border border-slate-200 rounded-md focus:outline-none focus:border-slate-400"
              [(ngModel)]="filters.date_to"
              (change)="onFilterChange()"
              placeholder="Bis Datum"
            />
          </div>

          <!-- Clear Filters -->
          <button
            (click)="clearFilters()"
            class="px-3 py-2 text-sm border border-slate-200 rounded-md hover:bg-slate-50 focus:outline-none focus:border-slate-400"
          >
            <mat-icon class="w-4 h-4 mr-1">clear</mat-icon>
            Reset
          </button>
        </div>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="loading" class="flex justify-center items-center py-8">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>

    <!-- Error Message -->
    <div *ngIf="!loading && dataSource.data.length === 0" class="text-center py-8">
      <mat-icon class="text-gray-400 w-24 h-24 mb-4">assessment</mat-icon>
      <p class="text-gray-500 text-lg">Keine Berichte gefunden</p>
    </div>

    <!-- Reports Table -->
    <div class="mt-8 flow-root" *ngIf="!loading && dataSource.data.length > 0">
      <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <table class="relative min-w-full divide-y divide-gray-300 dark:divide-white/15">
            <thead>
              <tr>
                <th scope="col" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">Einsatznummer</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Kunde</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Standort</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Techniker</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Erstellt</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Status</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Version</th>
                <th scope="col" class="whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
                  <span class="sr-only">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-900">
              <tr 
                *ngFor="let report of dataSource.data; let i = index" 
                class="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150"
                [ngClass]="{'bg-gray-50 dark:bg-gray-800': i % 2 === 1}">
                <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 dark:text-white">
                  {{ report.einsatznummer }}
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-900 dark:text-white">
                  {{ report.client_name }}
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <div class="font-medium">{{ report.standort_nummer }}: {{ report.standort_name }}</div>
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  {{ report.techniker_name }}
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  {{ formatDate(report.created_at) }}
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
                        [ngClass]="getStatusClass(report.status)">
                    {{ getStatusText(report.status) }}
                  </span>
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  v{{ report.version }}
                </td>
                <td class="whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                  <div class="flex space-x-2">
                    <button
                      (click)="viewReport(report); $event.stopPropagation()"
                      mat-icon-button
                      color="primary"
                      title="HTML Vorschau"
                      class="text-blue-600 hover:text-blue-800">
                      <mat-icon class="w-4 h-4">code</mat-icon>
                    </button>
                    <button
                      (click)="downloadReport(report); $event.stopPropagation()"
                      mat-icon-button
                      color="primary"
                      title="Download PDF"
                      class="text-green-600 hover:text-green-800">
                      <mat-icon class="w-4 h-4">download</mat-icon>
                    </button>
                    <button
                      (click)="viewKontrolltermin(report); $event.stopPropagation()"
                      mat-icon-button
                      color="primary"
                      title="Kontrolltermin anzeigen"
                      class="text-purple-600 hover:text-purple-800">
                      <mat-icon class="w-4 h-4">visibility</mat-icon>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Paginator -->
    <mat-paginator
      *ngIf="!loading && dataSource.data.length > 0"
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 25, 50]"
      (page)="onPageChange($event)"
      showFirstLastButtons
      aria-label="Select page of reports">
    </mat-paginator>
  </div>
</div>
